'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import styled from 'styled-components';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error appActions not yet typed
import { TEST_MODAL_TYPES, NO_TEST_ACCESS } from 'ContentEditorUI/lib/modalConstants';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { openModal as openModalAppAction, setTestType as setTestTypeAppAction } from 'ContentEditorUI/redux/actions/appActions';
import { closePatagoniaSidebar as closePatagoniaSidebarPanelAction } from 'ContentEditorUI/redux/actions/panelActions';
// @ts-expect-error Not migrated yet
import { clearQueryParam as clearQueryParamRoutingAction } from 'ContentEditorUI/redux/actions/routingActions';
import { getIsGenerativeAiEnabled } from 'ContentEditorUI/redux/selectors/contentAssistantSelectors';
import { getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getMABCreatableMap, getIsAnyTestRunning } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getActiveStagingDomain } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getPortalHasABTesting } from 'ContentEditorUI/redux/selectors/portalSelectors';
import { getPortalScopesRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { requestUninitialized, requestStarted, requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import { Map as ImmutableMap } from 'immutable';
import EPPatagoniaCategoryNavItem from 'editor-components/sidebar/EPPatagoniaCategoryNavItem';
import { getIsUngatedForAiAbLandingPages, getIsUngatedForConsolidatedAbMabTests } from '../redux/selectors/authSelectors';
import { AI_SETTINGS_URL } from '../constants/AiAbTestConstants';

// New selectable button UX for test type options when ungated for ConsolidatedAbMabTests:
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RunATestOption = ({
  dataTestId,
  description,
  disabledToolTip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
  }),
  isOptionDisabled,
  onClick,
  title
}) => /*#__PURE__*/_jsx(UITooltip, {
  disabled: !isOptionDisabled,
  title: disabledToolTip,
  children: /*#__PURE__*/_jsx(UISelectableButton, {
    block: true,
    className: "m-y-4 p-top-0",
    "data-test-id": dataTestId,
    description: /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "400",
      textAlign: "start",
      children: description
    }),
    disabled: isOptionDisabled,
    onClick: onClick,
    selected: false,
    size: "large",
    title: /*#__PURE__*/_jsx(Text, {
      as: "div",
      textAlign: "start",
      typography: "heading-100",
      children: title
    })
  })
});
const AbTestPql = ({
  isConsolidatedEntrypoint
}) => {
  const {
    openUpgradeModal: openABTestUpgradeModal
  } = useUpgradeModal('landing-pages-ab-testing-editor');
  if (isConsolidatedEntrypoint) {
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__ab--pql",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.ab.description"
      }),
      isOptionDisabled: false,
      onClick: openABTestUpgradeModal,
      title: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        justify: "between",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "mab.buttons.ab.header"
        }), /*#__PURE__*/_jsx(UILockBadge, {
          style: {
            width: 'auto'
          }
        })]
      })
    });
  }
  // This can be cleaned up once ConsolidatedAbMabTests is ungated to all:
  return /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
    iconRight: /*#__PURE__*/_jsx(UILockBadge, {}),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `patagonia.sidebar.toolsMenu.runABTest`
    }),
    onClick: openABTestUpgradeModal
  });
};
const MabTestPql = ({
  isConsolidatedEntrypoint
}) => {
  const {
    openUpgradeModal: openAdaptiveTestUpgradeModal
  } = useUpgradeModal('landing-pages-adaptive-testing-editor-content-hub');
  if (isConsolidatedEntrypoint) {
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__mab--pql",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.description"
      }),
      isOptionDisabled: false,
      onClick: openAdaptiveTestUpgradeModal,
      title: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        justify: "between",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "consolidatedRunTestEntryPoints.mab.title"
        }), /*#__PURE__*/_jsx(UILockBadge, {
          style: {
            width: 'auto'
          }
        })]
      })
    });
  }
  // This can be cleaned up once ConsolidatedAbMabTests is ungated to all:
  return /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
    iconRight: /*#__PURE__*/_jsx(UILockBadge, {}),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `patagonia.sidebar.toolsMenu.runMABTest`
    }),
    onClick: openAdaptiveTestUpgradeModal
  });
};
const mapStateToProps = state => ({
  isStagedContent: Boolean(getActiveStagingDomain(state)),
  portalHasABTesting: getPortalHasABTesting(state),
  portalScopesRequest: getPortalScopesRequest(state),
  mabCreatableMap: getMABCreatableMap(state),
  isAnyTestRunning: getIsAnyTestRunning(state),
  isUngatedForConsolidatedAbMabTests: getIsUngatedForConsolidatedAbMabTests(state),
  isLandingPage: getIsLandingPage(state),
  isUngatedForAiAbLandingPages: getIsUngatedForAiAbLandingPages(state),
  isGenerativeAiEnabled: getIsGenerativeAiEnabled(state)
});
const mapDispatchToProps = {
  openModal: openModalAppAction,
  setTestType: setTestTypeAppAction,
  clearQueryParam: clearQueryParamRoutingAction,
  closePatagoniaSidebar: closePatagoniaSidebarPanelAction
};
const AIBadgeWrapper = styled.div.withConfig({
  displayName: "PatagoniaRunATestWrapper__AIBadgeWrapper",
  componentId: "sc-1wbcgsk-0"
})([".ai-icon{width:auto !important;}"]);
class PatagoniaRunATestWrapper extends Component {
  constructor(...args) {
    super(...args);
    this.renderRunAiAbTestOption = () => {
      const {
        openModal,
        setTestType,
        portalScopesRequest,
        portalHasABTesting,
        isAnyTestRunning,
        isGenerativeAiEnabled,
        clearQueryParam,
        closePatagoniaSidebar
      } = this.props;
      const isMissingAbTesting = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
      if (isMissingAbTesting) {
        // TODO: Add pql for AiAb -- might need two, one for A/B and one for Breeze / Ai A/B?
        return null;
      }
      const isOptionDisabled = isAnyTestRunning || !isGenerativeAiEnabled;
      const ToolTipTitle = () => {
        if (isAnyTestRunning) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
          });
        }
        if (!isGenerativeAiEnabled) {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            elements: {
              Link: UILink
            },
            message: "aiAbTestFlow.disabledTooltip.genAi_jsx",
            options: {
              external: true,
              href: AI_SETTINGS_URL
            }
          });
        }
        return null;
      };
      return /*#__PURE__*/_jsx(RunATestOption, {
        dataTestId: "run-a-test__aiab",
        disabledToolTip: /*#__PURE__*/_jsx(ToolTipTitle, {}),
        isOptionDisabled: isOptionDisabled,
        onClick: () => {
          UsageTracker.trackEditorInteraction({
            action: 'Navigation Action',
            event: 'run-a-test-ai-ab'
          });
          // This can be cleaned up once ConsolidatedAbMabTests is ungated to all:
          clearQueryParam('runATestModalOpen');
          closePatagoniaSidebar();
          openModal(TEST_MODAL_TYPES.AI_AB_TEST);
          // openRunTestModal is a prop passed down from parent container that sets testType as a side-effect, while openModal does not.
          // Calling setTestType here, too, to ensure openTestType is set to 'aiab' to keep that consistent.
          setTestType(TEST_MODAL_TYPES.AI_AB_TEST);
        },
        title: /*#__PURE__*/_jsxs(UIFlex, {
          direction: "row",
          justify: "between",
          children: [/*#__PURE__*/_jsxs(UIFlex, {
            direction: "row",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "consolidatedRunTestEntryPoints.aiab.title"
            }), /*#__PURE__*/_jsx(UIHelpIcon, {
              className: "m-left-2",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "consolidatedRunTestEntryPoints.aiab.legalDisclaimer"
              })
            })]
          }), /*#__PURE__*/_jsx(AIBadgeWrapper, {
            children: /*#__PURE__*/_jsx(AIBadge, {})
          })]
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "consolidatedRunTestEntryPoints.aiab.description"
        })
      });
    };
  }
  renderInfoToolTip() {
    const {
      isAnyTestRunning
    } = this.props;
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
      }),
      placement: "right",
      children: isAnyTestRunning && /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        className: "m-left-1"
      })
    });
  }
  renderRunAbTestOption(shouldShowAiAbEntryPoint) {
    const {
      portalScopesRequest,
      portalHasABTesting,
      openRunTestModal,
      isAnyTestRunning,
      clearQueryParam,
      isUngatedForConsolidatedAbMabTests
    } = this.props;
    const showPql = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
    if (showPql) {
      return /*#__PURE__*/_jsx(AbTestPql, {
        isConsolidatedEntrypoint: isUngatedForConsolidatedAbMabTests
      });
    }
    const isOptionDisabled = isAnyTestRunning;
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__ab",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.ab.description"
      }),
      isOptionDisabled: isOptionDisabled,
      onClick: () => {
        // This can be cleaned up once ConsolidatedAbMabTests is ungated to all:
        clearQueryParam('runATestModalOpen');
        openRunTestModal(TEST_MODAL_TYPES.AB_TEST);
      },
      title: shouldShowAiAbEntryPoint ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.ab.title"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "mab.buttons.ab.header"
      })
    });
  }
  renderMAbTestOption() {
    const {
      mabCreatableMap,
      portalScopesRequest,
      openRunTestModal,
      isAnyTestRunning,
      clearQueryParam,
      isUngatedForConsolidatedAbMabTests
    } = this.props;
    const showMABPQL = mabCreatableMap.get('disabled') && mabCreatableMap.get('reason') === NO_TEST_ACCESS && requestSucceeded(portalScopesRequest);
    if (showMABPQL) {
      return /*#__PURE__*/_jsx(MabTestPql, {
        isConsolidatedEntrypoint: isUngatedForConsolidatedAbMabTests
      });
    }
    const isOptionDisabled = isAnyTestRunning;
    return /*#__PURE__*/_jsx(RunATestOption, {
      dataTestId: "run-a-test__mab",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.description"
      }),
      isOptionDisabled: isOptionDisabled,
      onClick: () => {
        // This can be cleaned up once ConsolidatedAbMabTests is ungated to all:
        clearQueryParam('runATestModalOpen');
        openRunTestModal(TEST_MODAL_TYPES.MAB_TEST);
      },
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "consolidatedRunTestEntryPoints.mab.title"
      })
    });
  }
  renderConsolidatedRunTestOptions() {
    const {
      isUngatedForAiAbLandingPages,
      isLandingPage
    } = this.props;
    const shouldShowAiAbEntryPoint = isUngatedForAiAbLandingPages && isLandingPage;
    return /*#__PURE__*/_jsxs(UIList, {
      childClassName: "m-right-4",
      children: [shouldShowAiAbEntryPoint && this.renderRunAiAbTestOption(), this.renderRunAbTestOption(shouldShowAiAbEntryPoint), this.renderMAbTestOption()]
    });
  }
  renderRunTestOption() {
    const {
      isAnyTestRunning,
      isStagedContent,
      portalHasABTesting,
      portalScopesRequest,
      mabCreatableMap,
      openRunTestModal,
      isUngatedForConsolidatedAbMabTests
    } = this.props;

    // Do not show PQL or create test button for staged content or if this page is already part of
    // a test (maybe when the user/account downgraded and no longer has the test scope)
    if (isStagedContent) {
      return null;
    }
    const showPQL = requestSucceeded(portalScopesRequest) && !portalHasABTesting;
    const showMABPQL = mabCreatableMap.get('disabled') && mabCreatableMap.get('reason') === NO_TEST_ACCESS && requestSucceeded(portalScopesRequest);
    if (isUngatedForConsolidatedAbMabTests) {
      return this.renderConsolidatedRunTestOptions();
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!showPQL && /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
        title: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `patagonia.sidebar.toolsMenu.runABTest`
          }), isAnyTestRunning && this.renderInfoToolTip()]
        }),
        onClick: () => openRunTestModal(TEST_MODAL_TYPES.AB_TEST),
        disabled: isAnyTestRunning
      }), showPQL && /*#__PURE__*/_jsx(AbTestPql, {}), !showMABPQL && /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
        title: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `patagonia.sidebar.toolsMenu.runMABTest`
          }), isAnyTestRunning && this.renderInfoToolTip()]
        }),
        onClick: () => openRunTestModal(TEST_MODAL_TYPES.MAB_TEST),
        disabled: isAnyTestRunning
      }), showMABPQL && /*#__PURE__*/_jsx(MabTestPql, {})]
    });
  }
  render() {
    const {
      portalScopesRequest
    } = this.props;
    if (requestStarted(portalScopesRequest) || requestUninitialized(portalScopesRequest)) {
      return null;
    }
    return this.renderRunTestOption();
  }
}
PatagoniaRunATestWrapper.propTypes = {
  isStagedContent: PropTypes.bool.isRequired,
  portalHasABTesting: PropTypes.bool.isRequired,
  portalScopesRequest: PropTypes.object.isRequired,
  openRunTestModal: PropTypes.func.isRequired,
  mabCreatableMap: PropTypes.instanceOf(ImmutableMap),
  isAnyTestRunning: PropTypes.bool.isRequired,
  isUngatedForConsolidatedAbMabTests: PropTypes.bool.isRequired,
  isLandingPage: PropTypes.bool.isRequired,
  isUngatedForAiAbLandingPages: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  isGenerativeAiEnabled: PropTypes.bool.isRequired,
  setTestType: PropTypes.func.isRequired,
  clearQueryParam: PropTypes.func.isRequired,
  closePatagoniaSidebar: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(PatagoniaRunATestWrapper);